/**
 * Small helpers shared by the evidence share dialogs (single- and
 * multi-video) for rendering station members in the recipient picker.
 */

/** Structural match for the station directory's user entries. */
export interface StationUser {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

/** Best available display label for a station member. */
export function userLabel(u: StationUser): string {
  const full = [u.firstName, u.lastName].filter(Boolean).join(" ").trim();
  return full || u.email || u.id;
}

/** Up to two initials from a display name, for the avatar. */
export function initials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}
